/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsUpRight = createReactComponent("outline", "arrows-up-right", "IconArrowsUpRight", [["path", { "d": "M17 21l4 -4l-4 -4", "key": "svg-0" }], ["path", { "d": "M21 17h-11a3 3 0 0 1 -3 -3v-11", "key": "svg-1" }], ["path", { "d": "M11 7l-4 -4l-4 4", "key": "svg-2" }]]);

export { IconArrowsUpRight as default };
//# sourceMappingURL=IconArrowsUpRight.mjs.map
